"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RootPage = exports.RootPageConfig = void 0;
var tslib_1 = require("tslib");
var mithril_1 = require("../mithril");
var services_1 = require("../services");
var page_1 = require("./page");
exports.RootPageConfig = {
    type: 'internal',
    name: page_1.IkePageName.root,
    path: '/',
    auth: { required: false },
    layout: { nav: false, banner: false }
};
var RootPage = /** @class */ (function (_super) {
    tslib_1.__extends(RootPage, _super);
    function RootPage() {
        return _super.call(this, exports.RootPageConfig) || this;
    }
    Object.defineProperty(RootPage.prototype, "nodes", {
        get: function () {
            return (0, mithril_1.m)('div', { onupdate: this.redirect, oncreate: this.redirect });
        },
        enumerable: false,
        configurable: true
    });
    RootPage.prototype.redirect = function () {
        // We check if the user is authenticated
        // so we don't have to do double refresh
        if (services_1.Services.User.isAuthenticated) {
            services_1.Services.Route.go(page_1.IkePageName.map);
        }
        else {
            services_1.Services.Route.go(page_1.IkePageName.login);
        }
    };
    return RootPage;
}(page_1.IkePage));
exports.RootPage = RootPage;
//# sourceMappingURL=root.page.js.map